export const ModuleFederationNXPost = () => {
  return (
    <article className='blog-post'>
      <h1>Micro‑frontends with Module Federation + NX in Two Minutes</h1>

      <h2>Context</h2>
      <p>
        Three feature teams blocked each other in a monorepo with a 45‑file
        pull‑request queue. Module Federation allowed them to deploy remote
        bundles independently, while NX orchestrated cached builds.
      </p>

      <h2>Webpack Extract</h2>
      <pre>
        {`// apps/sales/webpack.config.js
        const { ModuleFederationPlugin } = require('webpack').container;

        module.exports = {
          output: {
            publicPath: 'auto',
            uniqueName: 'sales',
          },
          plugins: [
            new ModuleFederationPlugin({
              name: 'sales',
              filename: 'remoteEntry.js',
              exposes: {
                './ProductCard': './src/components/ProductCard',
              },
              remotes: {
                shell: 'shell@http://localhost:4200/remoteEntry.js',
              },
              shared: {
                react: { singleton: true },
                'react-dom': { singleton: true },
              },
            }),
          ],
        };
        `}
      </pre>

      <h2>Results</h2>
      <ul>
        <li>Full CI build ≤ 2 min (was 12 min).</li>
        <li>Hotfix deploys roll out in 30 s without rebuilding the shell.</li>
      </ul>

      <h2>Tips</h2>
      <ul>
        <li>
          Generate configs with <code>nx g @nrwl/react:host</code> to avoid
          typos.
        </li>
        <li>Sign up for Nx Cloud to share cache between CI jobs.</li>
      </ul>

      <hr />
      <p className='cta'>
        Feedback welcome—reach me on{' '}
        <a
          className='link'
          href='https://www.linkedin.com/in/juan-marcelo-rodriguez-dev/'
          target='_blank'
          rel='noreferrer'
        >
          LinkedIn
        </a>
        .
      </p>
    </article>
  );
};
